import { Component, OnInit } from '@angular/core';
import { PuzzleService } from '../services/puzzle.service';
import { ActivatedRoute } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { APIResponse } from '../interfaces/response';
import { SafeResourceUrl } from '@angular/platform-browser';
import { LocalService } from '../services/local.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-candidate-external-wsp',
  templateUrl: './candidate-external-wsp.component.html',
  styleUrls: ['./candidate-external-wsp.component.css']
})
export class CandidateExternalWspComponent implements OnInit {

  haibuLogo: SafeResourceUrl = '../../assets/icons/haibu-icon.svg';
  isTokenValid: boolean = false;
  url: string = '';
  currentLang: string = '';

  constructor(
    private puzzleService: PuzzleService,
    private activatedRoute: ActivatedRoute,
    private swUpdate: SwUpdate,
    private localService: LocalService,
    private translate: TranslateService,
  ) {
    this.swUpdate.checkForUpdate();
    try {
      const token = this.activatedRoute.snapshot.queryParamMap.get('id');
      this.validateToken(token);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.initializeLanguage();
  }

  validateToken(token: string): void {
    this.puzzleService.validateVacancyToken(token).subscribe(
      (response: APIResponse) => {
        if (response.isSuccess) {
          this.isTokenValid = true;
          if (this.currentLang === 'esp') {
            this.url = `https://wa.me/528180832738?text=Hola!%20Estoy%20interesado%20en%20la%20vacante%20de%20${response.data.jobName}%20en%20${response.data.companyName}%20%5BId:%20${response.data.vacancyId}%5D`;
          } else {
            this.url = `https://wa.me/528180832738?text=Hello!%20I%20am%20interested%20in%20the%20vacancy%20of%20${response.data.jobName}%20at%20${response.data.companyName}%20%5BId:%20${response.data.vacancyId}%5D`;
          }
          this.redirectToWhatsApp();
        } else {
          this.isTokenValid = false;
        }
      },
      (error) => {
        console.error('An error occurred while validating token', error);
      },
    );
  }

  redirectToWhatsApp(): void {
    window.open(this.url, '_blank');
  }

  openWhatsAppWeb(): void {
    const url = this.url.replace('https://wa.me/', 'https://web.whatsapp.com/send?phone=');
    window.open(url, '_blank');
  }

  initializeLanguage() {
    if (this.localService.getJsonValue('lang')) {
      this.translate.use(this.localService.getJsonValue('lang'));
      this.currentLang = this.localService.getJsonValue('lang');
    } else {
      const browserLang = this.translate.getBrowserLang();
      let appLang = this.mapBrowserLangToAppLang(browserLang);
      this.translate.use(appLang);
      this.currentLang = appLang;
      this.localService.setJsonValue('lang', appLang);
    }
  }

  mapBrowserLangToAppLang(browserLang: string): string {
    const langMap = {
      en: 'eng',
      es: 'esp',
    };
    return langMap[browserLang] || 'eng';
  }
}
